module.exports = __webpack_public_path__ + "images/interview-Cisco_Systems-2.svg";